import * as React from 'react';
import * as ReactDOM from 'react-dom';

// Side Tab Types
export const SIDETAB_POSITION = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export type SIDETAB_POSITION = (typeof SIDETAB_POSITION)[keyof typeof SIDETAB_POSITION];

export const SIDETAB_SIZE = {
  SMALL: 'sm',
  MEDIUM: 'mg',
  MEDIUM_XL: 'md-xl',
  LARGE: 'lg',
  EXTRA_LARGE: 'xl',
} as const;

export type SIDETAB_SIZE = (typeof SIDETAB_SIZE)[keyof typeof SIDETAB_SIZE];

export interface SideTabProps {
  children: React.JSX.Element | React.JSX.Element[];
  title: string;
  scroll?: boolean;
  size?: SIDETAB_SIZE;
  position?: SIDETAB_POSITION;
  show?: boolean;
  id?: string;
  onClose?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const SideTab = (props: SideTabProps): React.JSX.Element => {
  const [title, setTitle] = React.useState<string>(props.title);
  const [show, setShow] = React.useState<boolean>(props.show || false);
  const [position, setPosition] = React.useState<SIDETAB_POSITION>(
    props.position || SIDETAB_POSITION.RIGHT
  );
  const [size, setSize] = React.useState<SIDETAB_SIZE>(props.size || SIDETAB_SIZE.LARGE);

  const arrowPosition = props.position === SIDETAB_POSITION.RIGHT ? 'left' : 'right';

  const classNames = ['side-tab', 'bg-body'];

  if (show === true) {
    classNames.push('show');
  }

  if (props.scroll === false) {
    classNames.push('no-scroll');
  }

  classNames.push('side-tab-' + size);
  classNames.push('side-tab-' + position);

  const containerProperties: React.InputHTMLAttributes<HTMLInputElement> = {
    className: classNames.join(' '),
  };

  if (props.id) {
    containerProperties.id = props.id;
  }

  React.useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  React.useEffect(() => {
    if (props.position) {
      setPosition(props.position);
    }
  }, [props.position]);

  React.useEffect(() => {
    if (props.title) {
      setTitle(props.title);
    }
  }, [props.title]);

  React.useEffect(() => {
    if (props.size) {
      setSize(props.size);
    }
  }, [props.size]);
  console.log(props);
  return ReactDOM.createPortal(
    <div {...containerProperties}>
      <div className="side-tab-inner">
        <div className="clearfix mb-3">
          <div
            className={`badge badge-secondary p-2 float-${arrowPosition}`}
            onClick={(e) => {
              setShow(false);

              if (props.onClose) {
                props.onClose(e);
              }
            }}
          >
            <i
              className={`fas fa-arrow-${position} align-${position === 'left' ? 'right' : 'left'}`}
            ></i>
          </div>
        </div>
        <div className="side-tab-head text-left">
          <h2>{title}</h2>
        </div>
        <div className="side-tab-body text-left">{props.children || ''}</div>
      </div>
    </div>,
    document.querySelector('body')
  );
};
